/* app/ui/header/nav.large */

define(
	'app/ui/header/nav.large',[
		'jquery',
		'pubsub'
	],
	function($) {

		var Module;

		var $menu;
		var selectors;
		var classes;

		var $navItems;
		var elementsInit = false;

		return {
			init: function($elm, selectorList, classList) {
				Module = this;
				$menu = $elm;
				selectors = selectorList;
				classes = classList;

				Module._initElements();
				Module._initEvents();
			},

			_initElements: function () {
				if (!elementsInit) {
					$navItems = $menu.find(selectors.navItem);
					elementsInit = true;
				}
			},

			_initEvents: function() {
				Module._bindTouchEvents();
			},

			_toggleMegaMenu: function(target, click, event) {

				if (click === 'click') {
					event.preventDefault();
				}

				var $link = $(target);
				var $scope = $link.closest(selectors.nav);
				var $item = $link.is(selectors.navItem) ? $link : $link.closest(selectors.navItem);
				var $childList = $item.closest(selectors.navChildren);

				// Alter scope if we're interacting with a child item
				// Ensure we close open children and not the parent item
				if ($childList.length) {
					$scope = $childList;
				}

				// If the item we're interacting with is being opened, close all it's siblings
				if (!$item.hasClass(classes.expanded)) {
					$scope.find('.' + classes.expanded).removeClass(classes.expanded);
				}

				$item.toggleClass(classes.expanded);
			},

			unbind: function () {
				$navItems.unbind('click', this._toggleMegaMenu);
				$navItems.unbind('mouseenter').unbind('mouseleave');
				$navItems.removeProp('hoverIntent_t');
				$navItems.removeProp('hoverIntent_s');
			},

			_toggleMegaMenuClick: function(event) {
				Module._toggleMegaMenu(this, 'click', event);
			},

			_bindTouchEvents: function() {
				for (var i = 0; i < $navItems.length; i++) {
					var $link = $navItems.eq(i).children(selectors.navLink);
					$link.on('click', Module._toggleMegaMenuClick);
				}
			}
		};
	}
);
